import {registerGraphNodeIn} from "@cm/graph-v3"

export const registerImageOpNode = registerGraphNodeIn("imageOp")
